// Date + status helpers for the redesigned CMS.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// Accepts ISO strings (backend) or Date objects. Returns "12 May 2026".
export const fmtDateShort = (d) => {
  if (!d) return '—'
  const date = new Date(d)
  if (Number.isNaN(date.getTime())) return '—'
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`
}

export const fmtTime = (d) => {
  if (!d) return '—'
  const date = new Date(d)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
}

export const fmtDateRange = (a, b) => {
  if (!a && !b) return 'Unscheduled'
  return `${fmtDateShort(a)} → ${fmtDateShort(b)}`
}

// "live" | "upcoming" | "past" | "neutral" — derived from the date window vs now.
export const periodTone = (start, end) => {
  if (!start || !end) return 'neutral'
  const now = Date.now()
  const s = new Date(start).getTime()
  const e = new Date(end).getTime()
  if (Number.isNaN(s) || Number.isNaN(e)) return 'neutral'
  if (now < s) return 'upcoming'
  if (now > e) return 'past'
  return 'live'
}

export const toneLabel = (tone) => {
  if (tone === 'live') return 'Live'
  if (tone === 'upcoming') return 'Upcoming'
  if (tone === 'past') return 'Completed'
  return '—'
}

// Backend group types are PascalCase ("RoundRobin", "Bracket"). Split for display.
export const prettyGroupType = (type) => (type ? type.replace(/([A-Z])/g, ' $1').trim() : 'Unknown')

// Short numeric badge for a gameday tile — its 1-based order (sortingIndex). NOT digits
// scraped from the name: gameday names can be dates like "01-02/05/2026", which would
// turn into "0102052026" and overflow the badge.
export const gamedayBadge = (gameday, fallbackIndex = 0) =>
  String((Number.isFinite(gameday?.sortingIndex) ? gameday.sortingIndex : fallbackIndex) + 1)

// Season status is derived from its date window (start/end vs now). NB: the backend's
// `Season.Active` flag is a CMS sync-eligibility flag, not a "currently running" signal,
// so it is intentionally not used here.
export const seasonTone = (season) => periodTone(season?.startDate, season?.endDate)

// Backend game.status is the WidgetGameStatus enum, serialized by name: "Upcoming" | "Live" | "Final".
export const isFinal = (game) => game?.status === 'Final'
export const isLive = (game) => game?.status === 'Live'

// Played = games with a final result. Falls back to 0 when status is absent.
export const countPlayed = (games = []) => games.filter(isFinal).length

// Backend enum strings ("NoRestriction", "NotSpecific") → "No Restriction".
export const prettyEnum = (s) => (s ? s.replace(/([A-Z])/g, ' $1').trim() : '')

// Reorder a list of {id} objects by a drag (source→dest index) and hand the resulting
// id order to `commit` (which persists it).
export const applyDrag = (items = [], sourceIndex, destIndex, commit) => {
  const ids = items.map((x) => x.id)
  const [moved] = ids.splice(sourceIndex, 1)
  ids.splice(destIndex, 0, moved)
  commit(ids)
}
